import s001List from '@/components/service/service-copy/list'
import s001Add from '@/components/service/service-copy/add'

let ServiceRouter = [
  {
    path: '/main/service/service-copy/list',
    name: 's001List',
    component: s001List
  },{
    path: '/main/service/service-copy/add',
    name: 's001Add',
    component: s001Add
  }
]

export default ServiceRouter
